import { render, staticRenderFns } from "./ItemShareSetting.vue?vue&type=template&id=0738c2db&lang=pug&"
import script from "./ItemShareSetting.vue?vue&type=script&lang=js&"
export * from "./ItemShareSetting.vue?vue&type=script&lang=js&"
import style0 from "./ItemShareSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VList,VMenu,VTextField})
